module.exports = __webpack_public_path__ + "img/full6-min.3a6d2779.png";